







import Vue from 'vue'
import { getColorContrast } from '@/services/get-color-contrast'

export default Vue.extend({
  name: 'AddressColorCellRenderer',

  props: {
    data: Array as () => any
  },

  computed: {
    getData(): any[] {
      return this.data
    }
  },

  methods: {
    getAddressStyle (item: string | null): Object {
      return {'background-color': `${item ? item : ''}`, 'color': `${getColorContrast(item ? item : '')}`}
    },
  }
})
